let initialState = {
};

export default function help(state = initialState, action) {
    return state;
}